class Promissory {
  static new(fn) {
    return new this(fn);
  }
  constructor(fn) {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
    if (fn) {
      fn(this);
    }
  }
  catch(fn) {
    this.promise = this.promise.catch(fn);
    return this;
  }
  finally(fn) {
    this.promise = this.promise.finally(fn);
    return this;
  }
  then(...args) {
    this.promise = this.promise.then(...args);
    return this;
  }
}
Promissory._$name = "Promissory";
export {
  Promissory as default
};
